import axios from 'axios'
import config from '@/config'
import store from '@/store'
import { expireSession } from '@/utils/sessionExpiry'

function handleAuthenticatedRequestError(error) {
  if (error.response && error.response.status === 401) {
    expireSession(store)
  }
  throw error
}

export default {
  async request(method, uri, isPrivateLink, data = null, headers = {}) {
    try {
      if (!method) {
        console.error('API function call requires method argument')
        return
      }

      if (!uri) {
        console.error('API function call requires uri argument')
        return
      }

      if (isPrivateLink) {
        headers.Authorization = store.state.token
      }

      var url = config.serverURI + uri
      const resp = await axios({
        method,
        url,
        headers,
        data
      })
      return resp
    } catch (error) {
      console.log(error)
      if (isPrivateLink && error.response && error.response.status === 401) {
        expireSession(store)
      }
      throw error
    }
  },
  download(url, method = 'GET', data) {
    return axios({
      method: method,
      url,
      responseType: 'arraybuffer',
      headers: {
        Authorization: store.state.token
      },
      data
    }).catch(handleAuthenticatedRequestError)
  },
  downloadPATCH(url, method = 'PATCH', data) {
    return axios({
      method: method,
      url,
      responseType: 'arraybuffer',
      headers: {
        Authorization: store.state.token
      },
      data
    }).catch(handleAuthenticatedRequestError)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js